<template>
  <div class="sub-navigation">
    <div class="sub-navigation-inner">
      <div class="sub-navigation-inner-left">
        <ul
          class="sub-navigation-list"
        >
          <template v-if="navSubItems && navSubItems.length > 0">
            <li
              v-for="(subItem, i) in navSubItems"
              :key="i"
              class="sub-navigation-list-item"
            >
              <kf-link
                class="sub-navigation-list-link"
                :href="subItem.href"
              >
                {{ subItem.label }}
              </kf-link>
            </li>
          </template>
        </ul>
      </div>
      <div class="sub-navigation-inner-right">
        <ul class="sub-navigation-extra-list">
          <li
            v-for="(subExtraItem, i) in navSubExtraItems.slice(0, 2)"
            :key="i"
            class="sub-navigation-extra-list-item"
          >
            <img
              class="sub-navigation-extra-list-image"
              :src="subExtraItem.imageSrc"
              :alt="subExtraItem.imageAlt"
              aria-hidden="true"
            >
            <kf-link
              class="sub-navigation-extra-list-link"
              type="bold"
              :href="subExtraItem.href"
            >
              {{ subExtraItem.label }}
            </kf-link>
            <p class="sub-navigation-extra-list-text">
              {{ subExtraItem.text }}
            </p>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import KfLink from '@/components/base/link/Link.vue';

export default {
  name: 'KfNavigationSub',
  components: {
    KfLink,
  },
  props: {
    navSubItems: {
      type: Array,
      default: () => [],
    },
    navSubExtraItems: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    scrollToElementIfLinkIsLocal(url, event) {
      if (url.startsWith('#')) {
        const targetElement = document.querySelector(url);

        event.preventDefault();

        if (targetElement) {
          targetElement.scrollIntoView({ behavior: 'smooth' });
        }
      }
    },
  },
};
</script>

<style lang="postcss">
.sub-navigation {
  @apply hidden absolute z-10 overflow-hidden left-0 bottom-0 w-full bg-white;
  transform: translateY(100%);

  &.is-open {
    @apply shadow-md;

    @screen lg {
      @apply flex;
    }
  }

  &::before {
    content: "";
    @apply absolute left-0 w-full shadow-md;
    top: -10px;
    height: 10px;
  }

  &::after {
    content: "";
    @apply absolute left-0 w-full shadow-md bg-white;
    top: -20px;
    height: 20px;
  }

  &-inner {
    @apply relative w-full mx-auto flex justify-end lg:container px-5 md:px-4 py-10;

    &-left {
      @apply p-0 pr-10 border-r border-gray-50;
      margin-left: 140px;
      width: 340px;

      @screen lg {
        margin-left: 140px;
        padding-right: 60px;
        width: 240px;
      }

      @screen xl {
        width: 340px;
      }
    }

    &-right {
      display: flex;
      flex-direction: row;
      flex: 1;
      width: calc(100% - 240px);
      margin: 0;
      padding-left: 40px;
      align-self: center;
      padding-left: 60px;
      width: calc(100% - 340px);
    }
  }

  &-list {
    &-item {
      @screen lg {
        @apply mb-3;
      }
      .sub-navigation-list-link {
        @apply no-underline;
        &:hover {
          @apply underline;
        }
      }
    }
  }

  &-extra {
    &-list {
      @apply flex;
      align-self: center;

      &-item {
        width: 50%;

        &:first-child {
          @apply pr-16;
        }
      }

      &-image {
        @apply object-contain mb-5;
        width: 128px;
        height: 115px;
      }

      &-link {
        @apply text-xl mb-1;

        &.is-bold {
          &::before {
            top: 9px;
            background-size: 14px 14px;
          }
        }
      }

      &-text {
        @apply text-base;
      }
    }
  }

  /* @screen lg {
    @apply relative h-full top-auto flex opacity-100;
    height: 55px;
    transform: translateY(0);
    overflow: inherit;
  } */
}
</style>
